import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import FriendSearch from "./FriendSearch";
import FriendRequests from "./FriendRequests";

const Navbar = ({ isAuthenticated, user, onLogout }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [showFriendRequests, setShowFriendRequests] = useState(false);
  const [friendRequestCount, setFriendRequestCount] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  console.log(user);

  useEffect(() => {
    if (isAuthenticated) {
      fetchFriendRequestCount();
    }
  }, [isAuthenticated]);

  const fetchFriendRequestCount = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DATABASE_URL}/api/users/friends/requests`
      );
      setFriendRequestCount(response.data.length);
    } catch (error) {
      console.error("Error fetching friend requests:", error);
    }
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    if (profileMenuOpen) setProfileMenuOpen(false);
  };

  const toggleProfileMenu = () => {
    setProfileMenuOpen(!profileMenuOpen);
    if (menuOpen) setMenuOpen(false);
  };

  const closeMenus = () => {
    setMenuOpen(false);
    setProfileMenuOpen(false);
  };

  const handleLogout = () => {
    closeMenus();
    onLogout();
  };

  const closeFriendRequests = () => {
    setShowFriendRequests(false);
    fetchFriendRequestCount(); // Refresh the count after closing
  };

  return (
    <>
      <nav className="bg-white shadow-md fixed w-full top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <Link
                to="/"
                className="flex-shrink-0 flex items-center"
                onClick={closeMenus}
              >
                <span className="font-bold text-xl bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
                  SnapTag
                </span>
              </Link>
            </div>

            {/* Search bar - visible on medium screens and up */}
            {isAuthenticated && (
              <div className="hidden md:flex md:items-center md:ml-6">
                <FriendSearch />
              </div>
            )}

            {/* Desktop navigation */}
            <div className="hidden md:flex md:items-center md:space-x-4">
              {isAuthenticated ? (
                <>
                  <Link
                    to="/feed"
                    onClick={closeMenus}
                    className={`px-3 py-2 rounded-md text-sm font-medium ${
                      location.pathname === "/feed"
                        ? "bg-purple-100 text-purple-600"
                        : "text-gray-700 hover:bg-gray-100"
                    }`}
                  >
                    My Photos
                  </Link>
                  <Link
                    to="/upload"
                    onClick={closeMenus}
                    className={`px-3 py-2 rounded-md text-sm font-medium ${
                      location.pathname === "/upload"
                        ? "bg-purple-100 text-purple-600"
                        : "text-gray-700 hover:bg-gray-100"
                    }`}
                  >
                    Upload
                  </Link>

                  {/* Friend request button with notification badge */}
                  <button
                    onClick={() => setShowFriendRequests(true)}
                    className="relative p-1 rounded-full text-gray-700 hover:bg-gray-100 focus:outline-none"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                      />
                    </svg>
                    {friendRequestCount > 0 && (
                      <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                        {friendRequestCount}
                      </span>
                    )}
                  </button>

                  {/* Profile dropdown */}
                  <div className="relative ml-3">
                    <div>
                      <button
                        onClick={toggleProfileMenu}
                        className="flex items-center space-x-2 p-1 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
                      >
                        <div className="h-8 w-8 rounded-full bg-purple-200 flex items-center justify-center overflow-hidden">
                          {user?.profilePhotoUrl ? (
                            <img
                              src={user.profilePhotoUrl}
                              alt={user.name}
                              className="h-full w-full object-cover"
                            />
                          ) : (
                            <span className="text-sm font-medium text-purple-700">
                              {user?.name?.charAt(0)?.toUpperCase() || "?"}
                            </span>
                          )}
                        </div>
                        <span className="text-sm font-medium text-gray-700 hidden lg:block">
                          {user?.name || "User"}
                        </span>
                        <svg
                          className="h-5 w-5 text-gray-400"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>
                    </div>

                    {/* Profile dropdown menu */}
                    {profileMenuOpen && (
                      <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1">
                        <Link
                          to={`/profile/${user?._id}`}
                          onClick={() => setProfileMenuOpen(false)}
                          className="block px-4 py-2 text-sm text-gray-700 hover:bg-purple-50 rounded-md"
                        >
                          Your Profile
                        </Link>
                        <Link
                          to="/settings"
                          onClick={() => setProfileMenuOpen(false)}
                          className="block px-4 py-2 text-sm text-gray-700 hover:bg-purple-50 rounded-md"
                        >
                          Settings
                        </Link>
                        <button
                          onClick={handleLogout}
                          className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 rounded-md"
                        >
                          Logout
                        </button>
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <Link
                    to="/login"
                    onClick={closeMenus}
                    className={`px-3 py-2 rounded-md text-sm font-medium ${
                      location.pathname === "/login"
                        ? "bg-purple-100 text-purple-600"
                        : "text-gray-700 hover:bg-gray-100"
                    }`}
                  >
                    Login
                  </Link>
                  <Link
                    to="/signup"
                    onClick={closeMenus}
                    className="ml-4 px-4 py-2 rounded-full text-sm font-medium text-white bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700"
                  >
                    Sign Up
                  </Link>
                </>
              )}
            </div>

            {/* Mobile menu button */}
            <div className="flex md:hidden">
              {isAuthenticated && (
                <button
                  onClick={() => setShowFriendRequests(true)}
                  className="relative p-2 mr-2 rounded-full text-gray-700 hover:bg-gray-100 focus:outline-none"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                    />
                  </svg>
                  {friendRequestCount > 0 && (
                    <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                      {friendRequestCount}
                    </span>
                  )}
                </button>
              )}

              <button
                onClick={toggleMenu}
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-100 focus:outline-none"
              >
                <svg
                  className={`${menuOpen ? "hidden" : "block"} h-6 w-6`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
                <svg
                  className={`${menuOpen ? "block" : "hidden"} h-6 w-6`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        <div className={`${menuOpen ? "block" : "hidden"} md:hidden`}>
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white shadow-lg">
            {isAuthenticated ? (
              <>
                {/* Search bar in mobile menu */}
                <div className="px-4 py-2">
                  <FriendSearch />
                </div>

                <div className="px-4 py-2">
                  <div className="flex items-center">
                    <div className="h-10 w-10 rounded-full bg-purple-200 flex items-center justify-center overflow-hidden">
                      {user?.profilePhotoUrl ? (
                        <img
                          src={user.profilePhotoUrl}
                          alt={user.name}
                          className="h-full w-full object-cover"
                        />
                      ) : (
                        <span className="text-lg font-medium text-purple-700">
                          {user?.name?.charAt(0)?.toUpperCase() || "?"}
                        </span>
                      )}
                    </div>
                    <span className="ml-3 text-base font-medium text-gray-800">
                      {user?.name || "User"}
                    </span>
                  </div>
                </div>

                <Link
                  to="/feed"
                  onClick={closeMenus}
                  className={`block px-3 py-2 rounded-md text-base font-medium ${
                    location.pathname === "/feed"
                      ? "bg-purple-100 text-purple-600"
                      : "text-gray-700 hover:bg-gray-100"
                  }`}
                >
                  My Photos
                </Link>

                <Link
                  to="/upload"
                  onClick={closeMenus}
                  className={`block px-3 py-2 rounded-md text-base font-medium ${
                    location.pathname === "/upload"
                      ? "bg-purple-100 text-purple-600"
                      : "text-gray-700 hover:bg-gray-100"
                  }`}
                >
                  Upload
                </Link>

                <Link
                  to={`/profile/${user?._id}`}
                  onClick={closeMenus}
                  className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100"
                >
                  Your Profile
                </Link>

                <Link
                  to="/settings"
                  onClick={closeMenus}
                  className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100"
                >
                  Settings
                </Link>

                <button
                  onClick={handleLogout}
                  className="w-full text-left block px-3 py-2 rounded-md text-base font-medium text-red-600 hover:bg-red-50"
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  onClick={closeMenus}
                  className={`block px-3 py-2 rounded-md text-base font-medium ${
                    location.pathname === "/login"
                      ? "bg-purple-100 text-purple-600"
                      : "text-gray-700 hover:bg-gray-100"
                  }`}
                >
                  Login
                </Link>
                <Link
                  to="/signup"
                  onClick={closeMenus}
                  className="block px-3 py-2 rounded-md text-base font-medium text-purple-600 hover:bg-purple-50"
                >
                  Sign Up
                </Link>
              </>
            )}
          </div>
        </div>
      </nav>

      {/* Friend Requests Modal */}
      <FriendRequests
        isOpen={showFriendRequests}
        onClose={closeFriendRequests}
      />
    </>
  );
};

export default Navbar;
